<div
  class="offcanvas-backdrop"
  *ngIf="visible"
  [style.opacity]="isClosing ? 0 : null"
  [style.transition]="isClosing ? 'opacity 0.28s ease' : null"
  (click)="onBackdropClick($event)">

  <div class="offcanvas-sheet"
       (click)="$event.stopPropagation()"
       [style.transform]="isClosing ? 'translateY(100%)' : 'translateY(' + swipeDeltaY + 'px)'"
       [style.transition]="isClosing ? 'transform 0.3s cubic-bezier(0.4,0,0.2,1)' : (swipeActive ? 'none' : 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)')"
       [style.opacity]="isClosing ? null : (1 - swipeProgress * 0.3)">

    <div class="sheet-handle-bar"
         (touchstart)="onHandleTouchStart($event)"
         (touchmove)="onHandleTouchMove($event)"
         (touchend)="onHandleTouchEnd()">
      <div class="sheet-handle"
           [style.width.px]="36 + swipeProgress * 20"
           [style.background]="'rgb(' + Math.round(222 + swipeProgress * -222) + ',' + Math.round(226 + swipeProgress * (122 - 226)) + ',' + Math.round(230 + swipeProgress * (143 - 230)) + ')'">
      </div>
    </div>

    <div class="sheet-header">
      <h6 class="sheet-title">{{ title }}</h6>
      <div class="sheet-header-right">
        <ng-content select="[sheetHeaderExtra]"></ng-content>
        <button class="sheet-close-btn" (click)="onClose()" aria-label="Close">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>

    <div class="sheet-body">
      <ng-content></ng-content>

      <ng-container *ngIf="showDefaultActions; else customActions">
        <div class="sheet-actions">
          <button class="btn btn-outline-secondary flex-fill" (click)="onClose()">{{ cancelLabel }}</button>
          <button class="btn btn-primary flex-fill" [disabled]="saveDisabled" (click)="onSave()">{{ saveLabel }}</button>
        </div>
      </ng-container>
      <ng-template #customActions>
        <ng-content select="[sheetActions]"></ng-content>
      </ng-template>
    </div>
  </div>
</div>
